module.exports = __webpack_public_path__ + "static/media/ccar.95d85206.png";